"use client";

import Script from "next/script";
import { useCallback } from "react";

export function YandexAdBanner({
  blockId,
  renderTo,
}: {
  blockId: string;
  renderTo: string;
}) {
  const renderBanner = useCallback(() => {
    if ("yaContextCb" in window) {
      window.yaContextCb?.push(() => {
        try {
          window.Ya?.Context.AdvManager.render({
            blockId: `${blockId}`,
            renderTo: `${renderTo}`,
          });
        } catch (e) {
          console.error(e);
        }
      });
    } else {
      console.warn("yaContextCb is not present in window");
    }
  }, [blockId, renderTo]);

  return (
    <>
      <Script
        id="yads"
        src="https://yandex.ru/ads/system/context.js"
        async
        onReady={renderBanner}
      />
      <div id={`${renderTo}`}></div>
    </>
  );
}
